var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnomo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731,
    height: 2000,
    viewBox: "0 0 1731 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.263 249.503L0 499.327V999.523V1499.72L432.502 1749.56L865.005 1999.4L1297.53 1749.55L1730.05 1499.7L1730.3 1299.6C1730.44 1189.54 1730.4 1099.5 1730.21 1099.5C1729.38 1099.5 1385.31 1298.58 1384.8 1299.35C1383.69 1301.05 865.841 1599.61 864.527 1599.31C863.786 1599.14 746.674 1531.72 604.279 1449.5L345.38 1300L345.37 999.496L345.361 698.996L603.278 549.996C745.133 468.046 862.182 400.607 863.389 400.131C865.226 399.406 893.486 415.377 1037.46 498.504C1131.99 553.085 1209.69 598.062 1210.12 598.453C1210.55 598.843 1094.17 666.59 951.507 749.002L692.111 898.841L692.366 998.406L692.62 1097.97L778.573 1147.77C825.847 1175.16 865.201 1197.4 866.025 1197.19C866.85 1196.98 983.584 1129.77 1125.43 1047.82C1267.28 965.879 1384.22 898.587 1385.29 898.286C1386.36 897.985 1464.37 853.161 1558.65 798.677L1730.05 699.614V599.429V499.244L1298.29 249.783C1060.82 112.579 866.075 0.176209 865.526 0.000208988C864.976 -0.176791 670.008 112.1 432.263 249.503Z",
    fill: "#DF0043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnomo);
export default __webpack_public_path__ + "static/media/enomo.72a5d951c0a6f15ae1f0eb47e7bff88b.svg";
export { ForwardRef as ReactComponent };